module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-900.383f9e8c.woff2";